module.exports = __webpack_public_path__ + "static/img/teamIntroduce.60fccb38.svg";